import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Button,
    Select,
    MenuItem,
    Typography,
    FormControl,
    InputLabel,
    Pagination,
    CircularProgress,
} from '@mui/material'
import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import apiUrl from '../../Config'

const DisplayEnquiry = () => {
    const [enquiry, setEnquiry] = useState([])
    const [editingId, setEditingId] = useState(null)
    const [newStatus, setNewStatus] = useState('')
    const [filterStatus, setFilterStatus] = useState('')

    const [page, setPage] = useState(1)
    const [limit, setLimit] = useState(10)
    const [totalPages, setTotalPages] = useState(1)
    const [totalItems, setTotalItems] = useState(0)

    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    const getAllEnquiry = async () => {
        try {
            setLoading(true)
            const requestBody = { page, limit }
            if (filterStatus) {
                requestBody.status = filterStatus
            }

            const response = await axios.post(`${apiUrl}/enquiries/getenquiry`, requestBody)

            setEnquiry(response.data.enquiries || [])
            setTotalPages(response.data.totalPages || 1)
            setTotalItems(response.data.totalItems !== undefined ? response.data.totalItems : (response.data.enquiries?.length || 0))
        } catch (error) {
            console.error(error)
            const message = error?.response?.data?.message || error.message || 'Failed to fetch enquiries'
            setError(message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        getAllEnquiry()
    }, [page, limit, filterStatus])

    const handleEditClick = (id, currentStatus) => {
        setEditingId(id)
        setNewStatus(currentStatus)
    }

    const handleStatusChange = (e) => {
        setNewStatus(e.target.value)
    }

    const handleSave = async (id) => {
        try {
            await axios.put(`${apiUrl}/enquiries/updateenquiry/${id}`, { status: newStatus })
            toast.success("Status updated successfully")
            setEditingId(null)
            setNewStatus('')
            getAllEnquiry()
        } catch (error) {
            console.error(error)
            const message = error?.response?.data?.message || error.message || 'Failed to update status'
            setError(message)
        }
    }

    const handleFilterChange = (e) => {
        setFilterStatus(e.target.value)
        setPage(1)
    }

    const handleLimitChange = (e) => {
        setLimit(Number(e.target.value))
        setPage(1)
    }

    return (
        <Box p={{ sm: 2, xs: 2, md: 4, lg: 4 }} mt={0.5}>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    mb: 2,
                    flexWrap: 'wrap',
                    gap: 2,
                }}
            >
                <Typography variant="h4" fontWeight={400}>
                    Enquiries
                </Typography>

                <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', flexWrap: 'wrap' }}>
                    <FormControl size="small" sx={{ minWidth: 160 }}>
                        <InputLabel>Status Filter</InputLabel>
                        <Select value={filterStatus} label="Status Filter" onChange={handleFilterChange}>
                            <MenuItem value="">All</MenuItem>
                            <MenuItem value="Pending">Pending</MenuItem>
                            <MenuItem value="Completed">Completed</MenuItem>
                            <MenuItem value="Cancel">Cancelled</MenuItem>
                        </Select>
                    </FormControl>

                    <FormControl size="small" sx={{ minWidth: 140 }}>
                        <InputLabel>Rows per page</InputLabel>
                        <Select value={limit} label="Rows per page" onChange={handleLimitChange}>
                            <MenuItem value={5}>5</MenuItem>
                            <MenuItem value={10}>10</MenuItem>
                            <MenuItem value={20}>20</MenuItem>
                        </Select>
                    </FormControl>
                </Box>
            </Box>

            {loading ? (
                <Box display="flex" justifyContent="center" alignItems="center" height={200}>
                    <CircularProgress />
                </Box>
            ) : (
                <>
                    <Typography variant="body2" sx={{ mb: 1 }}>
                        Total Enquiries: {totalItems}
                    </Typography>

                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>S.No</TableCell>
                                    <TableCell>Name</TableCell>
                                    <TableCell>Email</TableCell>
                                    <TableCell>Phone</TableCell>
                                    <TableCell>Message</TableCell>
                                    <TableCell>Status</TableCell>
                                    <TableCell>Action</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {enquiry.length === 0 ? (
                                    <TableRow>
                                        <TableCell colSpan={7} align="center">
                                            No enquiries found.
                                        </TableCell>
                                    </TableRow>
                                ) : (
                                    enquiry.map((row, index) => (
                                        <TableRow key={row.id}>
                                            <TableCell>{(page - 1) * limit + index + 1}</TableCell>
                                            <TableCell>{row.name}</TableCell>
                                            <TableCell>{row.email}</TableCell>
                                            <TableCell>{row.phoneNumber}</TableCell>
                                            <TableCell>{row.message}</TableCell>
                                            <TableCell>
                                                {editingId === row.id ? (
                                                    <Select value={newStatus} onChange={handleStatusChange} size="small">
                                                        <MenuItem value="Pending">Pending</MenuItem>
                                                        <MenuItem value="Completed">Completed</MenuItem>
                                                        <MenuItem value="Cancelled">Cancelled</MenuItem>
                                                    </Select>
                                                ) : (
                                                    row.status
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {editingId === row.id ? (
                                                    <Button variant="contained" size="small" onClick={() => handleSave(row.id)}>
                                                        Save
                                                    </Button>
                                                ) : (
                                                    <Button
                                                        variant="outlined"
                                                        size="small"
                                                        onClick={() => handleEditClick(row.id, row.status)}
                                                    >
                                                        Edit
                                                    </Button>
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    ))
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>

                    <Box mt={2} display="flex" justifyContent="center" alignItems="center">
                        <Pagination
                            count={totalPages > 0 ? totalPages : 1}
                            page={page > totalPages ? totalPages : page}
                            onChange={(event, value) => setPage(value)}
                            color="primary"
                            showFirstButton
                            showLastButton
                            disabled={totalPages === 0}
                            siblingCount={0}
                            boundaryCount={1}
                            sx={{
                                '& .MuiPaginationItem-root': {
                                    height: 30,
                                    minWidth: 30,
                                    fontSize: '1rem',
                                    marginTop: '10px'
                                }
                            }}
                        />
                    </Box>
                </>
            )}

            {error && (
                <Typography color="error" variant="body2" sx={{ mb: 2 }}>
                    {error}
                </Typography>
            )}
        </Box>
    )
}

export default DisplayEnquiry
